var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 6.5C14.875 6.77614 14.6511 7 14.375 7C14.0989 7 13.875 6.77614 13.875 6.5C13.875 6.22386 14.0989 6 14.375 6C14.6511 6 14.875 6.22386 14.875 6.5Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7H13.125V6H10.875V7Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.625 5.85761C6.625 4.69361 7.56861 3.75 8.73261 3.75H15.2674C16.4314 3.75 17.375 4.69361 17.375 5.85761V19.1424C17.375 20.3064 16.4314 21.25 15.2674 21.25H8.73261C7.56861 21.25 6.625 20.3064 6.625 19.1424V5.85761ZM8.73261 4.75C8.12089 4.75 7.625 5.24589 7.625 5.85761V19.1424C7.625 19.7541 8.12089 20.25 8.73261 20.25H15.2674C15.8791 20.25 16.375 19.7541 16.375 19.1424V5.85761C16.375 5.24589 15.8791 4.75 15.2674 4.75H8.73261Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Phone_2.0ee7e7e54399ac25369b4fa0b53f709d.svg";